/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var spine_options_pb = require('../../../../spine/options_pb.js');
var google_protobuf_any_pb = require('google-protobuf/google/protobuf/any_pb.js');
var spine_server_entity_entity_pb = require('../../../../spine/server/entity/entity_pb.js');
goog.exportSymbol('proto.spine.system.server.EntityColumns', null, global);
goog.exportSymbol('proto.spine.system.server.Mirror', null, global);
goog.exportSymbol('proto.spine.system.server.MirrorId', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.system.server.Mirror = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.system.server.Mirror, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.system.server.Mirror.displayName = 'proto.spine.system.server.Mirror';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.system.server.Mirror.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.system.server.Mirror.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.system.server.Mirror} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.Mirror.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && proto.spine.system.server.MirrorId.toObject(includeInstance, f),
    state: (f = msg.getState()) && google_protobuf_any_pb.Any.toObject(includeInstance, f),
    lifecycle: (f = msg.getLifecycle()) && spine_server_entity_entity_pb.LifecycleFlags.toObject(includeInstance, f),
    columns: (f = msg.getColumns()) && proto.spine.system.server.EntityColumns.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.Mirror}
 */
proto.spine.system.server.Mirror.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.Mirror;
  return proto.spine.system.server.Mirror.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.Mirror} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.Mirror}
 */
proto.spine.system.server.Mirror.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.spine.system.server.MirrorId;
      reader.readMessage(value,proto.spine.system.server.MirrorId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_any_pb.Any;
      reader.readMessage(value,google_protobuf_any_pb.Any.deserializeBinaryFromReader);
      msg.setState(value);
      break;
    case 3:
      var value = new spine_server_entity_entity_pb.LifecycleFlags;
      reader.readMessage(value,spine_server_entity_entity_pb.LifecycleFlags.deserializeBinaryFromReader);
      msg.setLifecycle(value);
      break;
    case 4:
      var value = new proto.spine.system.server.EntityColumns;
      reader.readMessage(value,proto.spine.system.server.EntityColumns.deserializeBinaryFromReader);
      msg.setColumns(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.system.server.Mirror.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.Mirror.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.Mirror} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.Mirror.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.spine.system.server.MirrorId.serializeBinaryToWriter
    );
  }
  f = message.getState();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter
    );
  }
  f = message.getLifecycle();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      spine_server_entity_entity_pb.LifecycleFlags.serializeBinaryToWriter
    );
  }
  f = message.getColumns();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.spine.system.server.EntityColumns.serializeBinaryToWriter
    );
  }
};


/**
 * optional MirrorId id = 1;
 * @return {?proto.spine.system.server.MirrorId}
 */
proto.spine.system.server.Mirror.prototype.getId = function() {
  return /** @type{?proto.spine.system.server.MirrorId} */ (
    jspb.Message.getWrapperField(this, proto.spine.system.server.MirrorId, 1));
};


/** @param {?proto.spine.system.server.MirrorId|undefined} value */
proto.spine.system.server.Mirror.prototype.setId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.system.server.Mirror.prototype.clearId = function() {
  this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.Mirror.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Any state = 2;
 * @return {?proto.google.protobuf.Any}
 */
proto.spine.system.server.Mirror.prototype.getState = function() {
  return /** @type{?proto.google.protobuf.Any} */ (
    jspb.Message.getWrapperField(this, google_protobuf_any_pb.Any, 2));
};


/** @param {?proto.google.protobuf.Any|undefined} value */
proto.spine.system.server.Mirror.prototype.setState = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.system.server.Mirror.prototype.clearState = function() {
  this.setState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.Mirror.prototype.hasState = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional spine.server.entity.LifecycleFlags lifecycle = 3;
 * @return {?proto.spine.server.entity.LifecycleFlags}
 */
proto.spine.system.server.Mirror.prototype.getLifecycle = function() {
  return /** @type{?proto.spine.server.entity.LifecycleFlags} */ (
    jspb.Message.getWrapperField(this, spine_server_entity_entity_pb.LifecycleFlags, 3));
};


/** @param {?proto.spine.server.entity.LifecycleFlags|undefined} value */
proto.spine.system.server.Mirror.prototype.setLifecycle = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.spine.system.server.Mirror.prototype.clearLifecycle = function() {
  this.setLifecycle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.Mirror.prototype.hasLifecycle = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional EntityColumns columns = 4;
 * @return {?proto.spine.system.server.EntityColumns}
 */
proto.spine.system.server.Mirror.prototype.getColumns = function() {
  return /** @type{?proto.spine.system.server.EntityColumns} */ (
    jspb.Message.getWrapperField(this, proto.spine.system.server.EntityColumns, 4));
};


/** @param {?proto.spine.system.server.EntityColumns|undefined} value */
proto.spine.system.server.Mirror.prototype.setColumns = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


proto.spine.system.server.Mirror.prototype.clearColumns = function() {
  this.setColumns(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.Mirror.prototype.hasColumns = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.system.server.MirrorId = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.system.server.MirrorId, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.system.server.MirrorId.displayName = 'proto.spine.system.server.MirrorId';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.system.server.MirrorId.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.system.server.MirrorId.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.system.server.MirrorId} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.MirrorId.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: (f = msg.getValue()) && google_protobuf_any_pb.Any.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.MirrorId}
 */
proto.spine.system.server.MirrorId.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.MirrorId;
  return proto.spine.system.server.MirrorId.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.MirrorId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.MirrorId}
 */
proto.spine.system.server.MirrorId.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_any_pb.Any;
      reader.readMessage(value,google_protobuf_any_pb.Any.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.system.server.MirrorId.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.MirrorId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.MirrorId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.MirrorId.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Any value = 1;
 * @return {?proto.google.protobuf.Any}
 */
proto.spine.system.server.MirrorId.prototype.getValue = function() {
  return /** @type{?proto.google.protobuf.Any} */ (
    jspb.Message.getWrapperField(this, google_protobuf_any_pb.Any, 1));
};


/** @param {?proto.google.protobuf.Any|undefined} value */
proto.spine.system.server.MirrorId.prototype.setValue = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.system.server.MirrorId.prototype.clearValue = function() {
  this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.MirrorId.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.system.server.EntityColumns = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.system.server.EntityColumns, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.system.server.EntityColumns.displayName = 'proto.spine.system.server.EntityColumns';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.system.server.EntityColumns.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.system.server.EntityColumns.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.system.server.EntityColumns} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.EntityColumns.toObject = function(includeInstance, msg) {
  var f, obj = {
    columnsMap: (f = msg.getColumnsMap()) ? f.toObject(includeInstance, proto.google.protobuf.Any.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.EntityColumns}
 */
proto.spine.system.server.EntityColumns.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.EntityColumns;
  return proto.spine.system.server.EntityColumns.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.EntityColumns} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.EntityColumns}
 */
proto.spine.system.server.EntityColumns.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getColumnsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.google.protobuf.Any.deserializeBinaryFromReader, "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.system.server.EntityColumns.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.EntityColumns.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.EntityColumns} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.EntityColumns.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getColumnsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.google.protobuf.Any.serializeBinaryToWriter);
  }
};


/**
 * map<string, google.protobuf.Any> columns = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.google.protobuf.Any>}
 */
proto.spine.system.server.EntityColumns.prototype.getColumnsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.google.protobuf.Any>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.google.protobuf.Any));
};


proto.spine.system.server.EntityColumns.prototype.clearColumnsMap = function() {
  this.getColumnsMap().clear();
};


goog.object.extend(exports, proto.spine.system.server);

// The code for parsing the Protobuf messages of this file from the JSON data.

let known_type_parsers = require('../../../../known_type_parsers.js');

proto.spine.system.server.Mirror.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.system.server.Mirror.fromObject(jsObject);
};

proto.spine.system.server.Mirror.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.system.server.Mirror();
  
  if (obj.id !== undefined) {
    if (obj.id === null) {
      msg.setId(null);
    } else {
      let value = proto.spine.system.server.MirrorId.fromObject(obj.id);
      msg.setId(value);
    }
  }
  
  if (obj.state !== undefined) {
    if (obj.state === null) {
      msg.setState(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Any');
      let value = parser.parse(obj.state);
      msg.setState(value);
    }
  }
  
  if (obj.lifecycle !== undefined) {
    if (obj.lifecycle === null) {
      msg.setLifecycle(null);
    } else {
      let value = proto.spine.server.entity.LifecycleFlags.fromObject(obj.lifecycle);
      msg.setLifecycle(value);
    }
  }
  
  if (obj.columns !== undefined) {
    if (obj.columns === null) {
      msg.setColumns(null);
    } else {
      let value = proto.spine.system.server.EntityColumns.fromObject(obj.columns);
      msg.setColumns(value);
    }
  }
  return msg;
};

proto.spine.system.server.MirrorId.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.system.server.MirrorId.fromObject(jsObject);
};

proto.spine.system.server.MirrorId.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.system.server.MirrorId();
  
  if (obj.value !== undefined) {
    if (obj.value === null) {
      msg.setValue(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Any');
      let value = parser.parse(obj.value);
      msg.setValue(value);
    }
  }
  return msg;
};

proto.spine.system.server.EntityColumns.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.system.server.EntityColumns.fromObject(jsObject);
};

proto.spine.system.server.EntityColumns.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.system.server.EntityColumns();
  
  if (obj.columns !== undefined && obj.columns !== null) {
    for (let attribute in obj.columns) {
      if (obj.columns.hasOwnProperty(attribute)) {
        let mapKey = attribute;
        if (obj.columns[attribute] === null) {
          msg.getColumnsMap().set(mapKey, null);
        } else {
          let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Any');
          let value = parser.parse(obj.columns[attribute]);
          msg.getColumnsMap().set(mapKey, value);
        }
      }
    }
  }
  return msg;
};
